import React from 'react'
import { boxes } from '../Contract'
import { Rectangle, RectangleTitle } from './box.styles'

interface BoxProps {
    index: number,
    box: boxes
}

export function Box({box, index}: BoxProps) {
    
    return <div key={index}>
    {(box.title) ?
        <RectangleTitle key={`${index}-RectangleTitle`}>{box.title}</RectangleTitle>
        : null
    }
    {(!box.collapseHide) ?
        <Rectangle key={`${index}-Rectangle`}>
            {box.element}
        </Rectangle> : null
    }
</div>
}